import React from 'react';
import { motion } from 'framer-motion';
const SPOTS_LEFT = 7;
const FILLED_PERCENT = 93;
export function ScarcityBar() {
  return <div className="mx-auto mt-6 w-full max-w-xl rounded-2xl border border-alert/20 bg-alert-soft p-4 text-left" data-id="element-34" data-mp="2yvt6ejrmzdvo">
      <div className="flex items-center justify-between gap-3" data-id="element-35" data-mp="2l2traivrnlon">
        <p className="flex items-center gap-2 text-sm font-bold text-alert" data-id="element-36" data-mp="2q2zcphbg0bya">
          <span className="relative flex h-2.5 w-2.5" data-id="element-37" data-mp="2b68kbs06s0i6">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-alert opacity-60" data-id="element-38" data-mp="2b8urhqj60dzv" />
            <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-alert" data-id="element-39" data-mp="2g3gvh8mx349x" />
          </span>
          Only {SPOTS_LEFT} spots left at the promotional price
        </p>
        <span className="text-sm font-extrabold text-alert" data-id="element-40" data-mp="275eweymqulpa">{FILLED_PERCENT}%</span>
      </div>
      <div className="mt-3 h-3.5 w-full overflow-hidden rounded-full bg-white" role="progressbar" aria-valuenow={FILLED_PERCENT} aria-valuemin={0} aria-valuemax={100} aria-label="Promotional spots claimed" data-id="element-41" data-mp="fgrob9frw5b">
        <motion.div className="h-full rounded-full bg-alert" initial={{
        width: '60%'
      }} whileInView={{
        width: `${FILLED_PERCENT}%`
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.9,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-42" data-mp="33ks7l97my5oc" />
      </div>
      <p className="mt-2 text-xs text-ink/70" data-id="element-43" data-mp="38ed9hcccnjst">When the spots run out, the price returns to its regular value.</p>
    </div>;
}